module.exports = __webpack_public_path__ + "img/iconInfo.f6fd683d.png";